import React from "react";
import {searchStudentTrails} from "./commonFilesJS/axiosRequests";
import {TrailEnums} from "./commonFilesJS/enums";
import TableAntD from "@common/TableAntD";

const TrailOpenContent = (props) => {
    const {key} = props;
    const {TRAIL_TABLE_COLUMNS} = TrailEnums();
    return <TableAntD
            pagingDependencies={[key]}
            pagingData={{fetchFunction:searchStudentTrails, params:{assignmentState:'OPEN'}}}
            columnData={TRAIL_TABLE_COLUMNS}
            rowKey={'key'}
            dynamicWidth={true}
        />
}
export default TrailOpenContent;
